import { Component } from '@angular/core';

@Component({
  selector: 'app-source-template-body',
  template: `
    <ng-content></ng-content>
  `,
})
export class SourceTemplateBodyComponent {}
